// @flow

export type RorProductSummary = {
  name: string,
  discountDayNames: string[],
  dateEffective: ?Date,
  endDate: ?Date,
  entryStationName: string,
  exitStationName: string,
  regionNames: string[],
  price: ?Number
}

const buildRorProductSummary = (name: string): RorProductSummary => {
  return {
    name: name,
    discountDayNames: [],
    dateEffective: null,
    endDate: null,
    entryStationName: '',
    exitStationName: '',
    regionNames: [],
    price: null
  }
}

export {
  buildRorProductSummary
}



// WEBPACK FOOTER //
// ./src/types/ror-product-summary.js